import { Tooltip } from '@material-ui/core';
import React from 'react';
import { ct } from '~/src/dash/publicaUI';

interface IFlexibleBiddingIconWithTooltipProps {
  placement?:
    | 'top'
    | 'left'
    | 'right'
    | 'bottom'
    | 'bottom-end'
    | 'bottom-start'
    | 'left-end'
    | 'left-start'
    | 'right-end'
    | 'right-start'
    | 'top-end'
    | 'top-start';
  width?: number;
  height?: number;
  title?: string;
}
export function FlexibleBiddingIconWithTooltip({
  placement = 'top',
  width = 16,
  height = 16,
  title = ct('BiddersTooltipFlexibleBiddingInfo'),
}: IFlexibleBiddingIconWithTooltipProps) {
  return (
    <Tooltip title={title} placement={placement}>
      <span>
        <img src='/assets/shared/svg/FlexBidding.svg' width={`${width}px`} height={`${height}px`} />
      </span>
    </Tooltip>
  );
}
